import React from 'react';

const NodeContext = React.createContext(null);

export default NodeContext;